export function ShiftTypeString(type) {
    if (type === "EARLY") return "Early";
    if (type === "LATE") return "Late";
    if (type === "TWILIGHT") return "Twilight";
    if (type === "NIGHT") return "Night";
    if (type === "LONG_DAY") return "Long Day";
    return type;
}
